export default {
  can: (state) => (action, name) => state.accessRights.can(action, name),
};
